export function trackNavClick(pageName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "clic_navbar", pageName });
}

export function trackAyudaClick(pageName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "clic_ayuda", pageName });
}

export function trackBannerClick(pageName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "clic_banner", pageName });
}

export function trackPlanesClick(planName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "clic_te_asesoramos_plan", planName });
}

export function trackFormSubmit(formulario, planName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "formulario_asesoramos_enviado", formulario, planName });
}
